import { render } from "./Notifications.vue?vue&type=template&id=7132c95a"
import script from "./Notifications.vue?vue&type=script&setup=true&lang=js"
export * from "./Notifications.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/components/Notifications.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7132c95a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7132c95a', __exports__)) {
    api.reload('7132c95a', __exports__)
  }
  
  module.hot.accept("./Notifications.vue?vue&type=template&id=7132c95a", () => {
    api.rerender('7132c95a', render)
  })

}


export default __exports__